import script from "./ProjectMainInfoImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectMainInfoImage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectMainInfoImage.vue?vue&type=style&index=0&id=e1d03a20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1d03a20"]])

export default __exports__